import styled from 'styled-components';
import { Form } from 'react-bootstrap';

export const FormWrapper = styled(Form)`
    margin-bottom: 20px;
    
    .sub-question {
        margin-left: 20px;
        margin-bottom: 15px;
        padding-bottom: 10px;
        border: solid #CCC;
        border-width: 0 0 0 1px;
    }

    // .panel > .panel-heading {
    //     background-image: none;
    //     background-color: whitesmoke;
    //     color: black;
    // }

    // & > .form-group {
    //     min-height: 30px;
    // }

    // & > .form-group:nth-child(odd) {
    //     background-color: #f9f9f9;
    // }

    .form-group > .control-label {
        text-align: left;
    }
`;
